import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const customerCategoryService = {
  fetchAllWithoutPaginate: async (params = {}) => {
    const response = await axiosInstance.get('/customer-category', {
      params,
    })
    return response.data
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/customer-category/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
      const response = await axiosInstance.get('/customer-category/' + id)
      return response.data
  },
  store: async (data) => {
      const response = await axiosInstance.post('/customer-category', data)
      return response.data
  },
  update: async (data) => {
      const response = await axiosInstance.put(`/customer-category/${data.id}`, data)
      return response.data
  },
  delete: async (id) => {
      const response = await axiosInstance.delete(`/customer-category/${id}`)
      return response.data
  },
}